import React, { useState } from 'react'

function AddManualTeamPlayer({player, playerSelected, setPlayerSelected, addPlayer, playersAdded, setPlayersAdded}) {

    const [show, setShow] = useState(false);
    const [team, setTeam] = useState("A")
    const [index, setIndex] = useState(0)

    function addPlayer() {
        console.log(playerSelected)
        const playerArray = [
            {
                player_name: playerSelected.player_name,
                index: index,
                player_id: playerSelected.player_id,
                team_name: team
            }
        ]

        const newArray = playersAdded.concat(playerArray)
        setPlayersAdded(newArray)
        console.log(newArray)

    }

    function toggle() {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    function isAdded(currentPlayer) {
        const isAdded = playersAdded?.filter(player => {
            return player.player_id === currentPlayer.player_id
        })
        if (isAdded.length) {
            return true
        } else {
            return false;
        }
    }

    return (
        <div 
            style={{cursor: "pointer"}} 
            className={isAdded(player) || playerSelected?.player_name === player.player_name ? "card card-body text-success" : "card card-body"}  
            onClick={() => setPlayerSelected(player)}
        >
            <div>
                {player.player_name} 
                
                <span className="float-right">{isAdded(player) ? "Lagt til" : <span><button className="btn btn-sm" onClick={toggle}>{show ? "x" : "+"}</button></span>}</span>
                {isAdded(player) ? "" : (
                    <React.Fragment>
                        {show && (
                            <React.Fragment>
                                <hr />
                                <br />
                                <label>Lag</label>
                                <input className="form-control mb-2" value={team} onChange={e => setTeam(e.target.value)}  />
                                
                                <label>Index</label>
                                <input type="number" className="form-control mb-2" value={index} onChange={e => setIndex(e.target.value)} />

                                <button onClick={addPlayer} className="btn btn-primary btn-block">Legg til</button>
                            </React.Fragment>
                        )}

                    </React.Fragment>
                )}
            </div>
        </div>
    )
}
export default AddManualTeamPlayer